module.exports = [{
      plugin: require('/usr/local/nginx/html/other_domains/strangemusichollywood/node_modules/gatsby-plugin-facebook-pixel/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/usr/local/nginx/html/other_domains/strangemusichollywood/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
